import Vue from "vue";
import Component from "vue-class-component";
import { Location } from "vue-router";
import { MUTATION_TYPES } from "@/store/const";

@Component
export default class WithStateRedirectPath extends Vue {
  public get stateRedirectPath(): Location | null {
    return this.$store.state.redirectPath;
  }

  public set stateRedirectPath(savedPath: Location | null) {
    this.$store.commit(MUTATION_TYPES.SET_REDIRECT_PATH, savedPath);
  }
}
